/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Youtube_Region_HelpInputs */

const en_live_caption_youtube_region_help = /** @type {(inputs: Live_Caption_Youtube_Region_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose where YouTube should position live captions on screen.`)
};

const fr_live_caption_youtube_region_help = /** @type {(inputs: Live_Caption_Youtube_Region_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez où YouTube doit positionner les sous-titres en direct à l'écran.`)
};

const de_live_caption_youtube_region_help = /** @type {(inputs: Live_Caption_Youtube_Region_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie aus, wo YouTube die Live-Untertitel auf dem Bildschirm positionieren soll.`)
};

const it_live_caption_youtube_region_help = /** @type {(inputs: Live_Caption_Youtube_Region_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli dove YouTube deve posizionare i sottotitoli in tempo reale sullo schermo.`)
};

const ru_live_caption_youtube_region_help = /** @type {(inputs: Live_Caption_Youtube_Region_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите, где YouTube должен размещать субтитры в режиме реального времени на экране.`)
};

const es_live_caption_youtube_region_help = /** @type {(inputs: Live_Caption_Youtube_Region_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige dónde debe YouTube colocar los subtítulos en directo en la pantalla.`)
};

const zh_cn2_live_caption_youtube_region_help = /** @type {(inputs: Live_Caption_Youtube_Region_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择 YouTube 在屏幕上显示实时字幕的位置。`)
};

const ja_live_caption_youtube_region_help = /** @type {(inputs: Live_Caption_Youtube_Region_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTubeのライブ字幕を画面上のどこに表示するかを選択してください。`)
};

const hi_live_caption_youtube_region_help = /** @type {(inputs: Live_Caption_Youtube_Region_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह चुनें कि YouTube स्क्रीन पर लाइव कैप्शन कहाँ प्रदर्शित करे।`)
};

const pt_pt2_live_caption_youtube_region_help = /** @type {(inputs: Live_Caption_Youtube_Region_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha onde o YouTube deve posicionar as legendas ao vivo na tela.`)
};

/**
* | output |
* | --- |
* | "Choose where YouTube should position live captions on screen." |
*
* @param {Live_Caption_Youtube_Region_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_youtube_region_help = /** @type {((inputs?: Live_Caption_Youtube_Region_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Youtube_Region_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_youtube_region_help(inputs)
	if (locale === "de") return de_live_caption_youtube_region_help(inputs)
	if (locale === "it") return it_live_caption_youtube_region_help(inputs)
	if (locale === "ru") return ru_live_caption_youtube_region_help(inputs)
	if (locale === "es") return es_live_caption_youtube_region_help(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_youtube_region_help(inputs)
	if (locale === "ja") return ja_live_caption_youtube_region_help(inputs)
	if (locale === "hi") return hi_live_caption_youtube_region_help(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_youtube_region_help(inputs)
	return en_live_caption_youtube_region_help(inputs)
});